import {
  SET_CURRENT_INDEX,
} from '../constants/actionTypes';

const initialState = {
  currentIndex: -1,
};

const actionMode = (state = initialState, action) => {
  switch (action.type) {
    case SET_CURRENT_INDEX:
      return {...state, currentIndex: action.payload};
    default:
      return state;
  }
}

export default actionMode;



// WEBPACK FOOTER //
// ./src/reducers/reducer-actionMode.js